import React from 'react'
import cx from 'classnames'
import { Dropdown, MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { rest, utils } from '../../lib'
import { Bell } from 'styled-icons/fa-regular/Bell'
import { Hdd } from 'styled-icons/fa-regular/Hdd'
import 'react-perfect-scrollbar/dist/css/styles.css'


class NavNotice extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      events: []
    }
  }

  componentDidMount = () => this.props.user.name && this.fetchEvent()
  fetchEvent = () => {
    console.log(this.props)
    rest.eventLatest().then( res => res && res.events && this.setState({ events: res.events }) )
  }

  content = items => {
    if (!items) return null

    return items.map( (item, i) => {
      const titleClass = cx('widget-notifications-title', {
        'text-info': item.level === 'INFO',
        'text-warning': item.level === 'WARN',
        'text-danger': item.level === 'CRITICAL',
      })
      const iconClass = cx('widget-notifications-icon', {
        'bg-info': item.level === 'INFO',
        'bg-warning': item.level === 'WARN',
        'bg-danger': item.level === 'CRITICAL',
      })

      return (
        <MenuItem key={i} className='widget-notifications-item'>
          <div className={titleClass}>{item.type}</div>
          <div className='widget-notifications-description'>{item.message}</div>
          <div className='widget-notifications-date'>{utils.formatDateTime(item.time)}</div>
          <div className={iconClass}><Hdd size={14}/></div>
        </MenuItem>
      )
    })
  }

  render() {
    return (
      <Dropdown id='nav-notification' componentClass='li'>

        <Dropdown.Toggle className='text-warning' useAnchor noCaret>
          <Bell size={14}/>
          <span className='px-navbar-label label label-info'>10</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className='p-a-0' style={{width: 300}}>
          <div className='ps-container ps-theme-default' style={{height: 280, position: 'relative'}}>
            <PerfectScrollbar>
              {this.content(this.state.events)}
            </PerfectScrollbar>
          </div>
          <LinkContainer className='widget-more-link' to='/event'>
            <MenuItem>MORE NOTIFICATIONS</MenuItem>
          </LinkContainer>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default NavNotice



// WEBPACK FOOTER //
// ./src/components/nav/NavNotice.js